import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  addDoc,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db } from "./Firebase";
import styled from "styled-components";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import MoonLoader from "react-spinners/MoonLoader";
import { TbFileCheck } from "react-icons/tb";
import { userName, userEmail } from "./UserData";

// Estilos del contenedor
const ContenedorDiv = styled.div`
  margin: 1rem 0rem 4.5rem 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; /* Ajustar al 100% del contenedor */
`;
const ContenedorDivModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0px 10px 0px 10px;
  color: black;
  input,
  select,
  textarea {
    border: none;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    border-radius: 2px;
    &:focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }
  }
  label {
    font-size: small;
    font-weight: bold;
  }
`;
const ContenedorInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  input {
    width: 40%;
  }
`;

// Estilos para la tabla
const ContenedorTabla = styled.div`
  width: 95%; /* Contenedor que se adapta al ancho completo */
  overflow-x: auto; /* Habilita el desplazamiento horizontal para pantallas pequeñas */
`;
const Tabla = styled.table`
  width: 100%; /* La tabla ocupa todo el ancho disponible */
  min-width: 900px; /* Establece un ancho mínimo para que se desplace en pantallas pequeñas */
  border-collapse: collapse;
  margin-top: 5px;
  color: black;
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
    white-space: nowrap; /* Evitar que se dividan en múltiples líneas */
    overflow: hidden;
    text-overflow: ellipsis; /* Texto truncado con ... si sobrepasa */
    max-height: 2.5em; /* Altura fija para una línea */
    line-height: 1.5em;
    height: 2.5em;
  }
  th {
    background-color: #f2f2f2;
  }
  th.actions,
  td.actions {
    width: 60px;
  }
  th.sticky-right,
  td.sticky-right {
    position: sticky; /* Hace que la columna sea fija */
    right: 0; /* La pega al lado derecho */
    background-color: white; /* Fondo blanco para que resalte */
    z-index: 2; /* Asegura que esté encima del contenido */
  }
`;

const BotonIcono = styled(TbFileCheck)`
  cursor: pointer;
  font-size: 28px; /* Tamaño del icono */
  &:hover {
    color: #c20000; /* Color rojo al hacer hover */
  }
`;

// Estilos de paginación
const PaginacionEstilos = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 16px 0px 16px;
  ul {
    display: flex;
    align-items: center;
    list-style-type: none;
    padding: 0;
  }

  li {
    text-align: center;
    min-width: 30px;
    cursor: pointer;
    border-radius: 4px;
    background-color: #f0f0f0;
    text-decoration: none;
    margin: 2px;
    color: black;
  }

  li:hover {
    background-color: #6c757d;
    color: white;
  }

  li.active {
    background-color: #c20000;
    color: white;
    font-weight: bold;
  }

  li.disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  li a {
    text-decoration: none; // Eliminar el subrayado
    color: inherit; // Usar el color del elemento padre (li)
  }
`;

// Botones de paginación
const BotonPaginacion = styled.button`
  padding: 5px 10px;
  border: none;
  background-color: #c20000; /* Rojo */
  color: white;
  cursor: pointer;
  &:hover {
    background-color: #6c757d; /* Gris en hover */
  }
`;

// Estilos para el modal
const EstiloModal = {
  content: {
    width: "35%",
    maxWidth: "100%", // No exceder el 100% del ancho
    minWidth: "300px", // Un ancho mínimo para evitar que sea demasiado pequeño
    margin: "5px", // Márgenes en pantallas pequeñas
    top: "10%", // Asegurar que el modal esté entre el nav y footer
    left: "50%",
    right: "auto",
    bottom: "5%", // Hacer que termine antes del footer
    transform: "translate(-50%, 0)", // Centrado horizontal
    backgroundColor: "white", // Fondo del modal
    overflowY: "auto", // Habilitar desplazamiento vertical
    maxHeight: "80vh", // Limitar el alto al 80% de la ventana
    padding: "10px", // Añadir un relleno interior
    borderRadius: "10px", // Bordes redondeados
    zIndex: 1000, // Asegurar que se mantenga en frente
  },
  overlay: {
    zIndex: 1000, // Mantener el modal sobre otros elementos
    backgroundColor: "rgba(0, 0, 0, 0.75)", // Oscurecer el fondo detrás del modal
  },
};

const BotonModal = styled.button`
  padding: 4px 8px;
  border: none;
  background-color: #c20000;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  margin: 2px;
  &:hover {
    background-color: #6c757d;
  }
`;

const ContenedorBotonesModal = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
`;

const ContenedorSpin = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  gap: 10px;
`;

function ConfirmarPresupuesto() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginaActual, setPaginaActual] = useState(0);
  const solicitudesPorPagina = 5;
  const [busqueda, setBusqueda] = useState("");
  const [modalAbierto, setModalAbierto] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [newFechaSalida, setNewFechaSalida] = useState("");
  const [newFechaRegreso, setNewFechaRegreso] = useState("");
  const [newLugarSalida, setNewLugarSalida] = useState("");
  const [newLugarDestino, setNewLugarDestino] = useState("");
  const [newUnidadesSolicitadas, setNewUnidadesSolicitadas] = useState("");
  const [newCantidadPasajeros, setNewCantidadPasajeros] = useState("");
  const [newObservaciones, setNewObservaciones] = useState("");
  const [firmaCorreo, setFirmaCorreo] = useState("");
  const [correoUsuario, setCorreoUsuario] = useState("");
  const [traficoSeleccionado, setTraficoSeleccionado] = useState("");

  useEffect(() => {
    setFirmaCorreo(userName); // Actualiza firmaCorreo con userName
    setCorreoUsuario(userEmail);
  }, []);

  useEffect(() => {
    const presupuestosCollection = collection(db, "presupuestos");
    const presupuestosQuery = query(
      presupuestosCollection,
      orderBy("fecha", "desc")
    );

    const unsubscribe = onSnapshot(presupuestosQuery, (snapshot) => {
      const presupuestosList = snapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          ...data,
          docId: doc.id,
          fechaOriginal: data.fecha?.toDate ? data.fecha.toDate() : data.fecha,
          fechaSalida: data.fechaSalida?.toDate
            ? data.fechaSalida.toDate()
            : data.fechaSalida,
          fechaRegreso: data.fechaRegreso?.toDate
            ? data.fechaRegreso.toDate()
            : data.fechaRegreso,
          confirmado: data.confirmado || false,
        };
      });

      // Ordena los presupuestos por fecha en tiempo real (por seguridad)
      presupuestosList.sort((a, b) => b.fechaOriginal - a.fechaOriginal);

      setData(presupuestosList);
      setLoading(false);
    });

    return () => unsubscribe(); // 🔥 Limpia la suscripción cuando el componente se desmonta
  }, []);

  const solicitudesActuales = data
    .filter((cliente) =>
      Object.values(cliente).some((valor) =>
        valor?.toString().toLowerCase().includes(busqueda.toLowerCase())
      )
    )
    .slice(
      paginaActual * solicitudesPorPagina,
      (paginaActual + 1) * solicitudesPorPagina
    );

  const totalPaginas = Math.ceil(
    data.filter((cliente) =>
      Object.values(cliente).some((valor) =>
        valor?.toString().toLowerCase().includes(busqueda.toLowerCase())
      )
    ).length / solicitudesPorPagina
  );

  const cambiarPagina = ({ selected }) => {
    const maxPagina =
      Math.ceil(
        data.filter((cliente) =>
          Object.values(cliente).some((valor) =>
            valor?.toString().toLowerCase().includes(busqueda.toLowerCase())
          )
        ).length / solicitudesPorPagina
      ) - 1;

    setPaginaActual(Math.min(selected, maxPagina));
  };

  const abrirModal = (cliente) => {
    setClienteSeleccionado(cliente);
    setNewObservaciones(cliente.observaciones);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setNewFechaSalida("");
    setNewFechaRegreso("");
    setNewLugarSalida("");
    setNewLugarDestino("");
    setNewUnidadesSolicitadas("");
    setNewCantidadPasajeros("");
    setNewObservaciones("");
    setClienteSeleccionado(null);
  };

  const enviarCorreo = async () => {
    if (!traficoSeleccionado) {
      alert(
        "Debe seleccionar una opción de tráfico antes de confirmar el presupuesto."
      );
      return;
    } else if (!firmaCorreo) {
      alert("Completar Ejecutivo Comercial.");
      return;
    }

    if (clienteSeleccionado) {
      cerrarModal();
      const { empresa, docId, totalServicio } = clienteSeleccionado;

      // Seleccionar los correos según la opción elegida en el select
      let correosDestino = [];
      if (traficoSeleccionado === "Mendoza") {
        correosDestino = [
         "trafico@catainternacional.com",
         "lobos_claudio@catainternacional.com",
        ];
      } else if (traficoSeleccionado === "Valle de Uco") {
        correosDestino = [
          "ramos_fernando@catainternacional.com",
          "estarriola_elio@catainternacional.com",
          "gomez_luis@transportesbmitre.com.ar",
        ];
      } else if (traficoSeleccionado === "Zona Sur") {
        correosDestino = [
          "arissa_marcelo@transportesbmitre.com.ar",
          "james_carina@catainternacional.com",
        ];
      }

      // Verificar si se ha proporcionado una nueva fecha, si no, usar la original
      const fechaSalidaFinal = newFechaSalida ? newFechaSalida : null; // Si no se proporciona una nueva fecha, no actualizamos en Firestore

      const fechaRegresoFinal = newFechaRegreso ? newFechaRegreso : null; // Si no se proporciona una nueva fecha, no actualizamos en Firestore

      // Crear el objeto con los valores que se van a actualizar
      const actualizaciones = {};

      // Actualizar las fechas solo si se han proporcionado
      if (fechaSalidaFinal) actualizaciones.fechaSalida = fechaSalidaFinal;
      if (fechaRegresoFinal) actualizaciones.fechaRegreso = fechaRegresoFinal;

      // Otras actualizaciones que siempre se aplican
      actualizaciones.lugarSalida =
        newLugarSalida || clienteSeleccionado.lugarSalida;
      actualizaciones.lugarDestino =
        newLugarDestino || clienteSeleccionado.lugarDestino;
      actualizaciones.cantidadPasajeros =
        newCantidadPasajeros || clienteSeleccionado.cantidadPasajeros;
      actualizaciones.unidadesSolicitadas =
        newUnidadesSolicitadas || clienteSeleccionado.unidadesSolicitadas;
      actualizaciones.observaciones =
        newObservaciones || clienteSeleccionado.observaciones;
      actualizaciones.confirmado = true;

      // Formato de las fechas para el correo
      const fechaSalidaFormateada = newFechaSalida
        ? new Date(newFechaSalida).toLocaleDateString("es-ES", {
            timeZone: "UTC",
          })
        : clienteSeleccionado.fechaSalida; // Mostrar la original si no se modificó

      const fechaRegresoFormateada = newFechaRegreso
        ? new Date(newFechaRegreso).toLocaleDateString("es-ES", {
            timeZone: "UTC",
          })
        : clienteSeleccionado.fechaRegreso; // Mostrar la original si no se modificó

      // Reemplazar los saltos de línea por <br /> en observaciones
      const observacionesFormateadas = actualizaciones.observaciones
        ? actualizaciones.observaciones.replace(/\n/g, "<br />")
        : "";

      // Enviar correo con las fechas formateadas
      await addDoc(collection(db, "mail"), {
        to: correosDestino,
        cc: [
          "sanchez_marisa@catainternacional.com",
          "mendoza_dairelys@catainternacional.com",
          "carmona_juliana@catainternacional.com",
          "rojas_dario@catainternacional.com",
          "director@catainternacional.com",
        ],
        from: `"Servicios Especiales" <${correoUsuario}>`, // 👈 este es el remitente visible
        replyTo: correoUsuario, // 👈 opcional, para respuestas
        message: {
          subject: `Servicio Confirmado - ${empresa}`,
          text: `Salida ${fechaSalidaFormateada}`,
          html: `
               <p style="margin: 0px; font-weight: bold;">Se ha confirmado el presupuesto con los siguientes datos:</p>
               <br>
               <p style="margin: 0px; font-weight: bold;">Presupuesto N°: ${docId}</p>
               <p style="margin: 0px;">Cliente: ${empresa}</p>
               <p style="margin: 0px;">Salida: ${fechaSalidaFormateada}</p>
               <p style="margin: 0px;">Regreso: ${fechaRegresoFormateada}</p>
               <p style="margin: 0px;">Lugar de Salida: ${actualizaciones.lugarSalida}</p>
               <p style="margin: 0px;">Destino: ${actualizaciones.lugarDestino}</p>
               <p style="margin: 0px;">Unidades Solicitadas: ${actualizaciones.unidadesSolicitadas}</p>
               <p style="margin: 0px;">Cantidad de Pasajeros: ${actualizaciones.cantidadPasajeros}</p>
               <br>
               <p style="margin: 0px; font-weight: bold;">Observaciones adicionales:</p>
               <p style="margin: 0px;">${observacionesFormateadas}</p>
               <br>
               <p style="margin: 0px; font-weight: bold;">Tarifa: ${totalServicio}</p>
               <br>
               <p style="margin: 0px; font-weight: bold;">Quedamos a la espera de la diagramación y confirmación de este correo.</p>
               <p style="margin: 0px; font-weight: bold;">Atte.</p>
               <p style="margin: 0px; font-weight: bold;">${firmaCorreo}</p>
               <hr>
               <p style="margin: 0px; font-size: 12px; color: #555;">
                 Este es un correo automático generado por el sistema de presupuestos de Servicios Especiales.
               </p>`,
        },
      });

      // Actualizar Firestore solo si hay cambios
      if (Object.keys(actualizaciones).length > 0) {
        const docRef = doc(db, "presupuestos", clienteSeleccionado.docId);
        await updateDoc(docRef, actualizaciones);
      }
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h4>Confirmar Presupuesto</h4>
      <input
        type="text"
        placeholder="Buscar por presupuesto o empresa"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{ padding: "3px", width: "50%" }}
      />
      <ContenedorDiv>
        {loading ? (
          <ContenedorSpin>
            <MoonLoader color="#c20000" size={50} />
            <p>Cargando presupuestos...</p>
          </ContenedorSpin>
        ) : (
          <>
            <ContenedorTabla>
              <Tabla>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Presupuesto</th>
                    <th>Nombre</th>
                    <th>Empresa</th>
                    <th>Contacto</th>
                    <th>Email</th>
                    <th>Salida</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Pax</th>
                    <th>Unidades</th>
                    <th>Regreso</th>
                    <th>Tarifa</th>
                    <th>Ejecutivo</th>
                    <th className={!clienteSeleccionado ? "sticky-right" : ""}>
                      Confirmar
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {solicitudesActuales.map((cliente) => (
                    <tr
                      key={cliente.docId}
                      style={{
                        backgroundColor: cliente.confirmado
                          ? "#4bd1b9"
                          : "white", // Color verde para confirmados
                      }}
                    >
                      <td>
                        {new Date(
                          new Date(cliente.fecha).toLocaleString("en-US", {
                            timeZone: "UTC",
                          })
                        ).toLocaleDateString("es-ES")}
                      </td>
                      <td>{cliente.docId}</td>
                      <td>{cliente.nombre}</td>
                      <td>{cliente.empresa}</td>
                      <td>{cliente.telefonoCliente}</td>
                      <td>{cliente.emailCliente}</td>
                      <td>
                        {new Date(
                          new Date(cliente.fechaSalida).toLocaleString(
                            "en-US",
                            {
                              timeZone: "UTC",
                            }
                          )
                        ).toLocaleDateString("es-ES")}
                      </td>
                      <td>{cliente.lugarSalida}</td>
                      <td>{cliente.lugarDestino}</td>
                      <td>{cliente.cantidadPasajeros}</td>
                      <td>{cliente.unidadesSolicitadas}</td>
                      <td>
                        {new Date(
                          new Date(cliente.fechaRegreso).toLocaleString(
                            "en-US",
                            {
                              timeZone: "UTC",
                            }
                          )
                        ).toLocaleDateString("es-ES")}
                      </td>
                      <td>{cliente.totalServicio}</td>
                      <td>{cliente.nombreEjecutivo}</td>
                      <td
                        className={!clienteSeleccionado ? "sticky-right" : ""}
                      >
                        <BotonIcono
                          title="Confirmar" /* Leyenda al pasar el mouse */
                          onClick={() =>
                            abrirModal(cliente)
                          } /* Función al hacer clic */
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Tabla>
            </ContenedorTabla>

            <PaginacionEstilos>
              <ReactPaginate
                previousLabel={<BotonPaginacion>Anterior</BotonPaginacion>}
                nextLabel={<BotonPaginacion>Siguiente</BotonPaginacion>}
                pageCount={totalPaginas}
                onPageChange={cambiarPagina}
                pageRangeDisplayed={1} // Mostrar 3 números de página intermedios
                marginPagesDisplayed={1} // Mostrar números al principio/final
                activeClassName={"active"} // Clase para la página actual
                containerClassName={"pagination"} // Clase de contenedor de paginación
                disabledClassName={"disabled"} // Clase para botones deshabilitados
              />
            </PaginacionEstilos>
          </>
        )}

        {/* Modal de confirmación */}
        <Modal
          isOpen={modalAbierto}
          onRequestClose={cerrarModal}
          style={EstiloModal}
          contentLabel="Confirmar"
        >
          {clienteSeleccionado && (
            <ContenedorDivModal>
              <h5>Confirmar Presupuesto para {clienteSeleccionado.empresa}</h5>
              <select onChange={(e) => setTraficoSeleccionado(e.target.value)}>
                <option value="">Selecciona tráfico</option>
                <option value="Mendoza">Tráfico Mendoza</option>
                <option value="Valle de Uco">Tráfico Valle de Uco</option>
                <option value="Zona Sur">Tráfico Zona Sur</option>
              </select>
              <ContenedorInput>
                <label>
                  Salida{" "}
                  {new Date(
                    new Date(clienteSeleccionado.fechaSalida).toLocaleString(
                      "en-US",
                      {
                        timeZone: "UTC",
                      }
                    )
                  ).toLocaleDateString("es-ES")}
                </label>
                <input
                  type="date"
                  value={newFechaSalida}
                  onChange={(e) => setNewFechaSalida(e.target.value)}
                />
              </ContenedorInput>
              <ContenedorInput>
                <label>
                  Regreso{" "}
                  {new Date(
                    new Date(clienteSeleccionado.fechaSalida).toLocaleString(
                      "en-US",
                      {
                        timeZone: "UTC",
                      }
                    )
                  ).toLocaleDateString("es-ES")}
                </label>
                <input
                  type="date"
                  value={newFechaRegreso}
                  onChange={(e) => setNewFechaRegreso(e.target.value)}
                />
              </ContenedorInput>
              <input
                type="text"
                placeholder={`Salida: ${clienteSeleccionado.lugarSalida}`}
                value={newLugarSalida}
                onChange={(e) => setNewLugarSalida(e.target.value)}
              />
              <input
                type="text"
                placeholder={`Destino: ${clienteSeleccionado.lugarDestino}`}
                value={newLugarDestino}
                onChange={(e) => setNewLugarDestino(e.target.value)}
              />
              <label>Cantidad y tipo de unidaes</label>
              <ContenedorInput>
                <input
                  type="text"
                  placeholder={`Unidades: ${clienteSeleccionado.unidadesSolicitadas}`}
                  value={newUnidadesSolicitadas}
                  onChange={(e) => setNewUnidadesSolicitadas(e.target.value)}
                />
                <input
                  type="number"
                  placeholder={`pax: ${clienteSeleccionado.cantidadPasajeros}`}
                  value={newCantidadPasajeros}
                  onChange={(e) => setNewCantidadPasajeros(e.target.value)}
                />
              </ContenedorInput>
              <textarea
                rows="5"
                placeholder={
                  clienteSeleccionado.observaciones
                    ? clienteSeleccionado.observaciones
                    : "Observaciones, (itinerario, telefonos de contacto, tipo de unidades...)"
                }
                value={newObservaciones}
                onChange={(e) => setNewObservaciones(e.target.value)}
              />
              <input
                type="text"
                placeholder="Ejecutivo comercial"
                value={firmaCorreo}
                onChange={(e) => setFirmaCorreo(e.target.value)}
              />
              <ContenedorBotonesModal>
                <BotonModal onClick={enviarCorreo}>Confirmar</BotonModal>
                <BotonModal onClick={cerrarModal}>Cancelar</BotonModal>
              </ContenedorBotonesModal>
            </ContenedorDivModal>
          )}
        </Modal>
      </ContenedorDiv>
    </div>
  );
}

export default ConfirmarPresupuesto;
